import React from 'react';
import Shimmer from '../Shimmer';
import * as styles from './style.module.css';

const CardSkeleton = ({ size = "small" }) => {

  if (size === "large") {
    return (
      <div className={styles.cardSkeleton}>
        <Shimmer width="60px" height="60px" />
        <Shimmer width="120px" height="16px" />
        <Shimmer width="100%" height="20px" />
        <Shimmer width="70%" height="20px" />
        <Shimmer width="80px" height="32px" />
      </div>
    );
  }


  return (
    <div className={styles.shadowWrapper}>
      <Shimmer width="100px" height="40px" />
      <div className={styles.singleRow}>
        <Shimmer width="80%" height="20px" />
        <Shimmer width="20%" height="20px" />
      </div>
    </div>
  )
};



export default CardSkeleton;
